module.exports = __webpack_public_path__ + "employees-21b62107/upload-a3282b78793010826cfdc2dc9eb81607.svg";